<template>
  <div class="map-view">
    <div
      id="containerMap"
      class="col-md-9"
    ></div>

    <div class="filters col-md-3">
      <h4>{{ $t('label.filter') }}</h4>
      <div
        class="filter"
        v-for="(field, index) in chartData.fields"
        :key="index"
      >
        <label :for="index">
          <input
            type="radio"
            v-model="selectedField"
            :value="field"
            :id="index"
          > {{ field }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts/highmaps'
import Europe from '@/assets/map-europe'
import Serbia from '@/assets/map-serbia'

export default {
  name: 'MapsView',
  data: function () {
    return {
      hmap: {},
      series: [],
      mapData: {},
      selectedField: undefined
    }
  },
  props: {
    chartData: undefined,
    chartOptions: undefined
  },
  mounted: function () {
    this.mapData['europe'] = Europe
    this.mapData['serbia'] = Serbia

    let MapData = this.mapData[this.chartData['mapType']]

    console.log(this.mapData['europe'])

    for (var country in this.chartData.values) {
      if (this.chartData.values.hasOwnProperty(country)) {
        if (this.chartData.values[country]['hc-key'] === 'eu') {
          /* eslint-disable */
          MapData["features"].push({
            "type": "Feature",
            "id": "eu",
            "properties": {
              "hc-key": "eu",
              "name": "European Union (28 countries)"
            },
            "geometry": {
              "type": "Polygon",
              "coordinates": [
                [
                  [-3500, 6000],
                  [0, 6000],
                  [0, 6500],
                  [-3500, 6500],
                ]
              ]
            }
          });
          /* eslint-enable */
          break
        }
      }
    }

    if (this.chartOptions) {
      let defaultConfig = {
        chart: {
          height: '100%',
          spacing: [12, 12, 12, 12],
          margin: [null],
          plotBorderColor: '#ffffff',
          map: MapData
        },
        exporting: {
          enabled: false
        },
        title: {
          align: 'left',
          style: { color: '#8D223B', fontSize: '1.25rem', fontWeight: 'bold', lineHeight: '1.5' }
        },
        tootlip: {
          backgroundColor: '#ffffff',
          borderRadius: '3',
          borderWidth: '0',
          style: { color: '#262626', boxShadow: '0 0 6px rgba(0,0,0,0.3)' }
        },
        series: [
          {
            mapData: MapData,
            borderColor: '#cccccc',
            states: {
              hover: {
                color: '#8D223B'
              }
            },
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              crop: false,
              format: '{point.name}'
            },
            name: 'Value'
          }
        ],
        colorAxis: {
          minColor: '#f5fff2',
          maxColor: '#618A51',
          gridLineColor: '#ffffff'
        },
        credits: {
          enabled: false
        },
        yAxis: {
          maxPadding: 0.05,
          labels: {
            step: 1
          }
        }
      }

      this.chartOptions = Object.assign({}, this.chartOptions, defaultConfig)
    }

    this.hmap = new Highcharts.Map('containerMap', this.chartOptions)
    this.selectedField = this.chartData.fields[0]
  },
  watch: {
    selectedField: function () {
      this.setData(this.selectedField)
    }
  },
  methods: {
    // set data updates the data on the map
    setData: function (field) {
      this.hmap.series[0].setData(this.getValuesForFieldInData(field, this.chartData.values))
      this.hmap.series[0].name = field
      this.hmap.series[0].update({
        tooltip: {
          pointFormatter: function () {
            return this.name + ': ' + this.value + (this.misc ? '*' : '')
          }
        }
      }, true)
      this.updateTitle(field)
    },
    // returns array of objects extracted from values object for given field
    getValuesForFieldInData: function (field, values) {
      var arr = []
      for (var key in values) {
        if (values.hasOwnProperty(key)) {
          let mapDataItem = {
            'hc-key': values[key]['hc-key'],
            'name': key,
            'value': parseFloat(values[key][field])
          }

          arr.push(mapDataItem)
        }
      }
      return arr
    },
    // updates the maps subtitle with selected field text
    updateTitle: function (field) {
      this.hmap.setTitle({
        text: field
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.map-view {
  position: relative;
}

.filters {
  position: absolute;
  top: 3rem;
  padding: 0;
  display: inline-block;
  border-radius: $border-radius-standard;
  box-shadow: $drop-shadow-card;
  overflow: hidden;
  background: white;

  @media (max-width: $device-sm) {
    position: static;
  }

  h4 {
    background: $primary-color;
    font-size: 0.75rem;
    text-transform: uppercase;
    color: $white;
    font-weight: $semibold;
    letter-spacing: 3px;
    padding: 0.75rem;
    border-bottom: 1px solid $border-color;
  }

  .filter {
    font-size: 0.85rem;
    padding: 0.25rem 0.75rem;

    * {
      display: inline-block;
      cursor: pointer;
    }

    input {
      margin-right: 0.25rem;
    }
  }
}

#containerMap {
  display: inline-block;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// MapsView.vue?0bb53ed8